"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GoGoEndCommand = void 0;
const Command_1 = require("../Command");
const CommandType_1 = require("../lib/CommandType");
/**
 * Marks the end of the Go-Go Time mode for notes. Don will be dancing, bar will
 * be glowing, and marker will be burning during this mode. Score is multiplied
 * by 1.2 for all notes hit during this mode. Can be placed in the middle of a
 * measure.
 */
class GoGoEndCommand extends Command_1.Command {
    constructor() {
        super(CommandType_1.CommandType.GoGoEnd);
    }
    static parse(_args) {
        return new GoGoEndCommand();
    }
}
exports.GoGoEndCommand = GoGoEndCommand;
